<template>
<div class="">
    <div class="d-sm-flex align-items-center justify-content-between mb-2">
        <div>
            <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/trips">Trips</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page" v-if="status">New Trip</li>
                <li class="breadcrumb-item active" aria-current="page" v-else>Update Trip</li>
            </ol>
            <h4 class="main-title mb-0">Trips</h4>
        </div>
        <div>
            <router-link to="/trips" type="button" class="btn btn-danger me-2"><i class="ri-close-line fs-18 lh-1"></i> Back</router-link>
            <button type="button" v-if="status" class="btn btn-primary me-2" @click="addTrip()"><i class="ri-save-line fs-18 lh-1"></i> Submit</button>
            <button type="button" v-if="!status && trip.status_flag != 2" class="btn btn-primary me-2" @click="updateTrip()"><i class="ri-save-line fs-18 lh-1"></i> Update</button>
        </div>
    </div>
    <div class="row">
        <div class="col-12 mb-2">
            <form>
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title" v-if="status">New Trip</h6>
                        <h6 class="card-title" v-else>Edit Trip</h6>
                    </div>
                    <div class="card-body ">
                        <div class="row g-2">
                            <div class="col-md-4">
                                <label class="form-label">Trip No.</label><span class="text-danger"> *</span>
                                <input type="text" placeholder="Trip No." disabled="disabled" class="form-control" :class="{ 'is-invalid': errors?.trip_no }" v-model="trip.trip_no" />
                                <span v-if="errors?.trip_no"><small class="text-danger">{{ errors?.trip_no[0] }}</small></span>
                            </div>
                            <!-- <div class="col-md-4">
                                <label class="form-label">Trip Date Time</label><span class="text-danger"> *</span>
                                <input type="date" placeholder="Trip Date Time" class="form-control" :class="{ 'is-invalid': errors?.trip_date_time }" :max="today" :value="convertDateFormat(trip.trip_date_time)" v-model="trip.trip_date_time" />
                                <span v-if="errors?.trip_date_time"><small class="text-danger">{{ errors?.trip_date_time[0] }}</small></span>
                            </div> -->
                            <div class="col-md-4">
                                <label class="form-label">Trip Date Time</label><span class="text-danger"> *</span>
                                <input type="datetime-local" placeholder="Trip Date Time" class="form-control" :class="{ 'is-invalid': errors?.trip_date_time }" :max="today" :value="convertDateTimeFormat(trip.trip_date_time)" v-model="trip.trip_date_time" />
                                <span v-if="errors?.trip_date_time"><small class="text-danger">{{ errors?.trip_date_time[0] }}</small></span>
                            </div>

                            <div class="col-md-4">
                                <label class="form-label">Customer</label><span class="text-danger"> *</span>
                                <!-- <select class="form-control" :class="{ 'is-invalid': errors.customer_id }" v-model="trip.customer_id">
                                        <option value="">Select Customer</option>
                                        <option v-for="customer, key in customers" :key="key" :value="customer.customer_id"> {{ customer.customer_name }}</option>
                                    </select> -->
                                <search :class="{ 'is-invalid': errors?.customer_id }" :customClass="{ 'is-invalid': errors?.customer_id }" :initialize="trip.customer_id" id="customer_id" label="customer_name" placeholder="Select Customer" :data=" customers" @input=" customer => trip.customer_id = customer">
                                </search>
                                <span v-if="errors?.customer_id" class="invalid-feedback">{{ errors?.customer_id[0] }}</span>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">Transporters</label><span class="text-danger"> *</span>
                                <!-- <select class="form-control" :class="{ 'is-invalid': errors.transporter_id }" v-model="trip.transporter_id">
                                        <option value="">Select Transporter</option>
                                        <option v-for="transporter, key in transporters" :key="key" :value="transporter.transporter_id"> {{ transporter.transporter_name }}</option>
                                    </select> -->
                                <search :class="{ 'is-invalid': errors?.transporter_id }" :customClass="{ 'is-invalid': errors?.transporter_id }" :initialize="trip.transporter_id" id="transporter_id" label="transporter_name" placeholder="Select Transporter" :data=" transporters" @input=" transporter => trip.transporter_id = transporter">
                                </search>
                                <span v-if="errors?.transporter_id" class="invalid-feedback">{{ errors?.transporter_id[0] }}</span>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">Wagon No.</label><span class="text-danger"> *</span>
                                <input type="text" placeholder="Lorry Wagon No." class="form-control" :class="{ 'is-invalid': errors?.wagon_no }" v-model="trip.wagon_no" @input="handleUpperCase" />
                                <span v-if="errors?.wagon_no" class="invalid-feedback">{{ errors?.wagon_no[0] }}</span>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">Container No.</label>
                                <input type="text" placeholder="Container No." class="form-control" :class="{ 'is-invalid': errors?.container_no }" v-model="trip.container_no" @input="handleUpperCase" />
                                <span v-if="errors?.container_no" class="invalid-feedback">{{ errors?.container_no[0] }}</span>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">Destination</label><span class="text-danger"> *</span>
                                <input type="text" placeholder="Destination" class="form-control" :class="{ 'is-invalid': errors?.destination }" v-model="trip.destination" />
                                <span v-if="errors?.destination" class="invalid-feedback">{{ errors?.destination[0] }}</span>
                            </div>
                            <div class="col-md-12">
                                <label class="form-label">Note</label>
                                <textarea rows="2" type="text" placeholder="Note" class="form-control" :class="{ 'is-invalid': errors?.note }" v-model="trip.note"></textarea>
                                <span v-if="errors?.note" class="invalid-feedback">{{ errors?.note[0] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="col-12">
            <!-- <form > -->
            <div class="card mb-2" v-for="slip,key in trip.slips" :key="key">
                <div class="card-header d-flex justify-content-between">
                    <h6 class="card-title">Slip</h6>
                    <button v-if="key==0" type="button" class="btn btn-outline-success" @click.prevent="addSlip()"><i class="ri-add-line fs-18 lh-1"></i></button>
                    <button v-else type="button" class="btn btn-outline-danger" @click.prevent="deleteSlip(slip, key)"><i class="ri-close-line fs-18 lh-1"></i></button>
                </div>
                <div class="card-body ">
                    <div class="row mb-3 g-2">
                        <div class="col-md-4">
                            <label class="form-label">Slip No.</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Slip No." class="form-control" :class="{ 'is-invalid': slip?.errors?.slip_no }" v-model="slip.slip_no" />
                            <span v-if="slip.errors.slip_no" class="invalid-feedback">{{ slip.errors.slip_no[0] }}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Slip Date</label><span class="text-danger"> *</span>
                            <input type="date" placeholder="Slip Date Time" class="form-control" :class="{ 'is-invalid': slip.errors.slip_date_time }" :max="today" :value="convertDateFormat(slip.slip_date_time)" v-model="slip.slip_date_time" />
                            <span v-if="slip.errors.slip_date_time" class="invalid-feedback">{{ slip.errors.slip_date_time[0] }}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Work Order No.</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Work Order No." class="form-control" :class="{ 'is-invalid': slip.errors.work_order_no }" v-model="slip.work_order_no" />
                            <span v-if="slip.errors.work_order_no" class="invalid-feedback">{{ slip.errors.work_order_no[0] }}</span>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label">Product</label><span class="text-danger"> *</span>
                            <!-- <select class="form-control" :class="{ 'is-invalid': errors.product_id }" v-model="slip.product_id">
                                    <option value="">Select Product</option>
                                    <option v-for="product, key in products" :key="key" :value="product.product_id"> {{ product.product_name }}</option>
                                </select> -->
                            <search :class="{ 'is-invalid': slip.errors.product_id }" :customClass="{ 'is-invalid': slip.errors.product_id }" :initialize="slip.product_id" id="product_id" label="product_name" placeholder="Select Product" :data=" products" @input=" product => slip.product_id = product">
                            </search>
                            <span v-if="slip.errors.product_id" class="invalid-feedback">{{ slip.errors.product_id[0] }}</span>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Packing</label>
                            <!-- <select class="form-control" :class="{ 'is-invalid': errors.packing_id }" v-model="slip.packing_id">
                                    <option value="">Select Packing</option>
                                    <option v-for="packing, key in packings" :key="key" :value="packing.packing_id"> {{ packing.packing_name }}</option>
                                </select> -->
                            <search :class="{ 'is-invalid': slip.errors.packing_id }" :customClass="{ 'is-invalid':slip. errors.packing_id }" :initialize="slip.packing_id" id="packing_id" label="packing_name" placeholder="Select Packing" :data=" packings" @input=" packing => slip.packing_id = packing">
                            </search>
                            <span v-if="slip.errors.packing_id" class="invalid-feedback">{{ slip.errors.packing_id[0] }}</span>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Loading Type</label>
                            <!-- <select class="form-control" :class="{ 'is-invalid': errors.loading_type_id }" v-model="slip.loading_type_id">
                                    <option value="">Select Loading Type</option>
                                    <option v-for="loading_type, key in loading_types" :key="key" :value="loading_type.loading_type_id"> {{ loading_type.loading_type_name }}</option>
                                </select> -->

                            <search :class="{ 'is-invalid': slip.errors.loading_type_id }" :customClass="{ 'is-invalid': slip.errors.loading_type_id }" :initialize="slip.loading_type_id" id="loading_type_id" label="loading_type_name" placeholder="Select Loading Type" :data=" loading_types" @input=" loading_type => slip.loading_type_id = loading_type">
                            </search>
                            <span v-if="slip.errors.loading_type_id" class="invalid-feedback">{{ slip.errors.loading_type_id[0] }}</span>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Pallet Size</label>
                            <!-- <select class="form-control" :class="{ 'is-invalid': errors.pallet_size_id }" v-model="slip.pallet_size_id">
                                    <option value="">Select Pallet Size</option>
                                    <option v-for="pallet_size, key in pallet_sizes" :key="key" :value="pallet_size.pallet_size_id"> {{ pallet_size.pallet_size_name }}</option>
                                </select> -->
                            <search :class="{ 'is-invalid': slip.errors.pallet_size_id }" :customClass="{ 'is-invalid': slip.errors.pallet_size_id }" :initialize="slip.pallet_size_id" id="pallet_size_id" label="pallet_size_name" placeholder="Select Pallet Size" :data=" pallet_sizes" @input=" pallet_size => slip.pallet_size_id = pallet_size">
                            </search>
                            <span v-if="slip.errors.pallet_size_id" class="invalid-feedback">{{ slip.errors.pallet_size_id[0] }}</span>
                        </div>
                    </div>

                    <div class="row g-2">
                        <div class="">
                            <table class="table table-responsive table-responsive-sm table-sm text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th>Storage <span class="text-danger"> *</span></th>
                                        <th>Lot No. <span class="text-danger"> *</span></th>
                                        <th>Loading Bags <span class="text-danger"> *</span></th>
                                        <th>Loading Quantity <span class="text-danger"> *</span></th>
                                        <th class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <!-- {{ slip }} -->
                                <tbody>
                                    <tr>
                                        <td>
                                            <!-- <select class="form-control" :class="{ 'is-invalid':slip.errors.storage_id }" v-model="slip.lot.storage_id">
                                                    <option value="">Select Storage</option>
                                                    <option v-for="storage, key in storages" :key="key" :value="storage?.storage_id"> {{ storage.storage_name }}</option>
                                                </select> -->
                                            <search :class="{ 'is-invalid': slip.errors.storage_id }" :customClass="{ 'is-invalid': slip.errors.storage_id }" :initialize="slip.lot.storage_id" id="storage_id" label="storage_name" placeholder="Select Storage" :data=" storages" @input=" storage => slip.lot.storage_id = storage">
                                            </search>
                                            <span v-if="slip.errors.storage_id" class="invalid-feedback">{{ slip.errors.storage_id[0] }}</span>
                                        </td>
                                        <td>
                                            <input type="text" class="form-control" placeholder="Lot No." :class="{ 'is-invalid': slip.errors.lot_no }" v-model="slip.lot.lot_no" />
                                            <span v-if="slip.errors.lot_no" class="invalid-feedback">{{ slip.errors.lot_no[0] }}</span>
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" placeholder="Loading Bags" :class="{ 'is-invalid': slip.errors.loading_bags }" v-model="slip.lot.loading_bags" />
                                            <span v-if="slip.errors.loading_bags" class="invalid-feedback">{{ slip.errors.loading_bags[0] }}</span>
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" placeholder="Loading Quantity" :class="{ 'is-invalid': slip.errors.loading_quantity }" v-model="slip.lot.loading_quantity" />
                                            <span v-if="slip.errors.loading_quantity" class="invalid-feedback">{{slip.errors.loading_quantity[0] }}</span>
                                        </td>
                                        <td class="text-center">
                                            <button v-if="slip.status" class="btn btn-outline-success mx-1" @click.prevent="addRow(slip)"><i class="ri-add-line fs-18 lh-1"></i></button>
                                            <button v-else class="btn btn-outline-success mx-1" @click.prevent="updateRow(slip)"><i class="ri-save-line fs-18 lh-1"></i></button>
                                            <button class="btn  btn-outline-danger mx-1" @click.prevent="discardNewRow(slip)"><i class="ri-close-line fs-18 lh-1"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody>
                                    <tr v-for="lot, index in slip.lots" :key="index">
                                        <!-- <td class="text-center">{{ lot?.storage_id }}</td>s -->
                                        <td>{{ getStorageName(lot.storage_id) }}</td>
                                        <td>{{ lot?.lot_no }}</td>
                                        <td>{{ lot?.loading_bags }}</td>
                                        <td>{{ lot?.loading_quantity }}</td>
                                        <td class="text-center">
                                            <button type="button" class="btn btn-outline-primary mx-2" @click.prevent="editLot(slip, lot,index)"><i class="ri-pencil-line fs-18 lh-1"></i></button>
                                            <button type="button" class="btn btn-outline-danger" @click.prevent="deleteLot(slip,lot,index)"><i class="ri-delete-bin-line fs-18 lh-1"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- </form> -->
        </div>
    </div>
</div>
</template>

<script>
import Search from "@/components/Search.vue";
import Pagination from "@/components/Pagination.vue";
import moment from "moment";
export default {
    components: {
        Pagination,
        Search
    },
    data() {
        return {
            trip: {
                trip_no: "",
                trip_date_time: "",
                container_no: "",
                // work_order_no: "",
                customer_id: "",
                transporter_id: "",
                wagon_no: "",
                container_no: "",
                destination: "",
                note: "",
                slips: [],
                deleted_lots: [],
                deleted_slips: [],
            },
            status: true,
            customers: [],
            transporters: [],
            products: [],
            packings: [],
            loading_types: [],
            pallet_sizes: [],
            storages: [],
            errors: [],
            today: ''
        };
    },
    mounted() {
        // this.index();
        this.getCustomers();
        this.trip.trip_date_time = moment().format('yyyy-MM-DD HH:mm:ss')
        this.today = moment().format('yyyy-MM-DD')
        //this.trip.date_time = moment().format('yyyy-MM-DD hh:mm:ss')
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            // vm.getRoles();
            if (to.name == "Trip.Create") {
                // vm.$refs.trip_no.focus();
                vm.generateTripNo();
                vm.addSlip();
            } else {
                vm.status = false;
                vm.trip.trip_id = to.params.trip_id;
                let uri = {
                    uri: "getTrip",
                    data: vm.trip
                };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        // console.log(response.data.data,"response")
                        // vm.work_order = response.data.data;
                        vm.trip = response.data.data;
                        vm.trip.trip_date_time = moment(vm.trip.trip_date_time).format('yyyy-MM-DD HH:mm:ss');
                        //vm.trip.date_time = vm.trip.trip_date_time 
                        vm.trip.deleted_lots = [];
                        vm.trip.deleted_slips = [];
                        // vm.user.avatar = vm.$store.getters.assetUrl+'/users/'+vm.user.avatar
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            }
        });
    },

    methods: {
        handleUpperCase() {
            this.trip.wagon_no = this.trip.wagon_no ?.toUpperCase();
            this.trip.container_no = this.trip.container_no ?.toUpperCase();
        },
        
      // validateDate(slip) {
        //     let dateRegex = /^\d{4}-\d{2}-\d{2}$/; // Regex without quotes
        //     if (!slip.slip_date_time.match(dateRegex)) {
        //         slip.errors.slip_date_time = ['Invalid date format'];
        //         console.log("Invalid:", slip.slip_date_time);
        //     } else {
        //         delete slip.errors.slip_date_time;
        //         console.log("Valid:", slip.slip_date_time);
        //     }
        // },

        generateTripNo() {
            let vm = this;
            let uri = {
                uri: "generateTripNo"
            };
            vm.$store
                .dispatch("post", uri)
                .then(function (response) {
                    vm.trip.trip_no = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        addTrip() {
            let vm = this;
            vm.trip.slips.map(function (slip) {
                if (!slip.slip_no) {
                    slip.errors.slip_no = ["Slip no. field cannot be empty"]
                } else {
                    delete slip.errors.slip_no
                }
                if (!slip.slip_date_time) {
                    slip.errors.slip_date_time = ["Slip date field cannot be empty"]
                } else {
                    delete slip.errors.slip_date_time
                }
                if (!slip.work_order_no) {
                    slip.errors.work_order_no = ["Work order no. field cannot be empty"]
                } else {
                    delete slip.errors.work_order_no
                }
                if (!slip.product_id) {
                    slip.errors.product_id = ["Product Id field cannot be empty"]
                } else {
                    delete slip.errors.product_id
                }
            })
            //vm.trip.trip_date_time = vm.trip.date_time
            let loader = vm.$loading.show();
            let uri = {
                uri: "addTrip",
                data: vm.trip
            };
            vm.$store
                .dispatch("post", uri)
                .then(function (response) {
                    loader.hide();
                    vm.$store.dispatch("success", response.data.message);
                    vm.$router.push("/trips");
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        updateTrip() {
            let vm = this;
            //vm.trip.trip_date_time = vm.trip.date_time
            vm.trip.slips.map(function (slip) {
                if (!slip.slip_no) {
                    slip.errors.slip_no = ["Slip no. field cannot be empty"]
                } else {
                    delete slip.errors.slip_no
                }
                if (!slip.slip_date_time) {
                    slip.errors.slip_date_time = ["Slip date field cannot be empty"]
                } else {
                    delete slip.errors.slip_date_time
                }
                if (!slip.work_order_no) {
                    slip.errors.work_order_no = ["Work order no. field cannot be empty"]
                } else {
                    delete slip.errors.work_order_no
                }
                if (!slip.product_id) {
                    slip.errors.product_id = ["Product Id field cannot be empty"]
                } else {
                    delete slip.errors.product_id
                }
            })
            let loader = vm.$loading.show();
            let uri;
            if(vm.trip.status == 'Completed'){
                uri = {
                    uri: "updateCompletedTrip",
                    data: vm.trip
                };
            }
            else
            {
                uri = {
                    uri: "updatePendingTrip",
                    data: vm.trip
                };
            }
            vm.$store
                .dispatch("post", uri)
                .then(function (response) {
                    loader.hide();
                    // console.log(response)
                    vm.$store.dispatch("success", response.data.message);
                    vm.$router.push("/trips");
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        getCustomers() {
            let vm = this;
            let uri = {
                uri: "getCustomers"
            };
            vm.$store
                .dispatch("post", uri)
                .then(function (response) {
                    vm.customers = response.data.data;
                    vm.getTransporters();

                    // vm.addSlip();
                })
                .catch(function (error) {
                    vm.errors = error.response.data;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        getTransporters() {
            let vm = this;
            let uri = {
                uri: "getTransporters"
            };
            vm.$store
                .dispatch("post", uri)
                .then(function (response) {
                    vm.transporters = response.data.data;
                    vm.getProducts();
                })
                .catch(function (error) {
                    vm.errors = error.response.data;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        getProducts() {
            let vm = this;
            let uri = {
                uri: "getProducts"
            };
            vm.$store
                .dispatch("post", uri)
                .then(function (response) {
                    vm.products = response.data.data;
                    vm.getPackings();
                })
                .catch(function (error) {
                    vm.errors = error.response.data;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        getPackings() {
            let vm = this;
            let uri = {
                uri: "getPackings"
            };
            vm.$store
                .dispatch("post", uri)
                .then(function (response) {
                    vm.packings = response.data.data;
                    vm.getLoadingTypes();
                })
                .catch(function (error) {
                    vm.errors = error.response.data;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        getLoadingTypes() {
            let vm = this;
            let uri = {
                uri: "getLoadingTypes"
            };
            vm.$store
                .dispatch("post", uri)
                .then(function (response) {
                    vm.loading_types = response.data.data;
                    vm.getPalletSizes();
                })
                .catch(function (error) {
                    vm.errors = error.response.data;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        getPalletSizes() {
            let vm = this;
            let uri = {
                uri: "getPalletSizes"
            };
            vm.$store
                .dispatch("post", uri)
                .then(function (response) {
                    vm.pallet_sizes = response.data.data;
                    vm.getStorages();
                })
                .catch(function (error) {
                    vm.errors = error.response.data;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        getStorages() {
            let vm = this;
            let uri = {
                uri: "getStorages"
            };
            vm.$store
                .dispatch("post", uri)
                .then(function (response) {
                    vm.storages = response.data.data;
                })
                .catch(function (error) {
                    vm.errors = error.response.data;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        addRow(slip) {
            let vm = this;
            vm.errors = [];
            if (slip.lot.storage_id == "" || slip.lot.lot_no == "" || slip.lot.loading_bags == "" || slip.lot.loading_quantity == "") {
                if (slip.lot.storage_id == "") {
                    slip.errors.storage_id = ["Storage field cannot be empty"];
                }
                if (slip.lot.lot_no == "") {
                    slip.errors.lot_no = ["Lot No. cannot be empty"];
                }
                if (slip.lot.loading_bags == "") {
                    slip.errors.loading_bags = ["Loading Bags field cannot be empty"];
                }
                if (slip.lot.loading_quantity == "") {
                    slip.errors.loading_quantity = ["Loading Quantity field cannot be empty"];
                }
            } else {
                slip.lots.push({
                    lot_id: "",
                    storage_id: slip.lot.storage_id,
                    lot_no: slip.lot.lot_no,
                    loading_bags: slip.lot.loading_bags,
                    loading_quantity: slip.lot.loading_quantity,
                });
                vm.discardNewRow(slip);
            }
        },
        discardNewRow(slip) {
            let vm = this;
            slip.lot.storage_id = "";
            slip.lot.lot_no = "";
            slip.lot.loading_bags = "";
            slip.lot.loading_quantity = "";
            slip.status = true;
            slip.errors = [];
        },
        updateRow(slip) {
            let vm = this;
            console.log(slip);
            vm.errors = [];
            if (slip.lot.storage_id == "" || slip.lot.lot_no == "" || slip.lot.loading_bags == "" || slip.lot.loading_quantity == "") {
                if (slip.lot.storage_id == "") {
                    slip.errors.storage_id = ["Storage field cannot be empty"];
                }
                if (slip.lot.lot_no == "") {
                    slip.errors.lot_no = ["Lot No. cannot be empty"];
                }
                if (slip.lot.loading_bags == "") {
                    slip.errors.loading_bags = ["Loading Bags field cannot be empty"];
                }
                if (slip.lot.loading_quantity == "") {
                    slip.errors.loading_quantity = ["Loading Quantity field cannot be empty"];
                }
            } else {
                let lot_data = slip.lots.filter(function (element) {
                    return element.lot_id == slip.lot.lot_id;
                });
                console.log("ddd", lot_data)
                if (lot_data.length) {
                    lot_data[0].storage_id = slip.lot.storage_id;
                    lot_data[0].lot_no = slip.lot.lot_no;
                    lot_data[0].loading_bags = slip.lot.loading_bags;
                    lot_data[0].loading_quantity = slip.lot.loading_quantity;
                    vm.discardNewRow(slip);
                }
            }
        },
        getStorageName(id) {
            let obj = this.storages.find((o) => o ?.storage_id === id);
            if (obj) {
                return obj.storage_name;
            }
        },
        editLot(slip, lot, key) {
            let vm = this;
            slip.lot.lot_id = lot.lot_id;
            slip.lot.storage_id = lot.storage_id;
            slip.lot.lot_no = lot.lot_no;
            slip.lot.loading_bags = lot.loading_bags;
            slip.lot.loading_quantity = lot.loading_quantity;
            slip.status = false;
            vm.errors = [];
        },
        deleteLot(slip, lot, key) {
            let vm = this;
            console.log(vm.trip);
            let sl = vm.trip.slips.filter(function (element) {
                return element.slip_id == lot.slip_id;
            });
            console.log(sl);
            if (confirm("Are you sure you want to delete")) {
                vm.trip.deleted_lots.push(lot.lot_id);
                // console.log("deleted", trip.deleted_lots);W
                slip.lots.splice(key, 1);
                vm.discardNewRow(slip);
            }
        },
        addSlip() {
            let vm = this;
            if (vm.trip.slips.length == 0) {
                vm.trip.slips.push({
                    slip_id: "",
                    slip_no: "",
                    slip_date_time: "",
                    work_order_no: "",
                    product_id: "",
                    packing_id: "",
                    loading_type_id: "",
                    pallet_size_id: "",
                    status: true,
                    lots: [],
                    work_order_no: "",
                    loading_type_id: "",
                    pallet_size_id: "",
                    lot: {
                        lot_id: "",
                        storage_id: "",
                        lot_no: "",
                        loading_bags: "",
                        loading_quantity: "",
                    },
                    errors: []
                });
            } else {
                let previous_slip = vm.trip.slips[vm.trip.slips.length - 1]
                previous_slip.errors = [];
                if (!previous_slip.slip_no || !previous_slip.work_order_no || !previous_slip.product_id || !previous_slip.slip_date_time || !previous_slip.lots.length) {
                    if (previous_slip.slip_no == "") {
                        previous_slip.errors.slip_no = ["Slip no. field cannot be empty"]
                    } else {
                        delete previous_slip.errors.slip_no
                    }
                    if (previous_slip.work_order_no == "") {
                        previous_slip.errors.work_order_no = ["Work order no. field cannot be empty"]
                    } else {
                        delete previous_slip.errors.work_order_no
                    }
                    if (previous_slip.product_id == "") {
                        previous_slip.errors.product_id = ["Product id field cannot be empty"]
                    } else {
                        delete previous_slip.errors.product_id
                    }
                    if (previous_slip.slip_date_time == "") {
                        previous_slip.errors.slip_date_time = ["Slip date field cannot be empty"]
                    } else {
                        delete previous_slip.errors.slip_date_time
                    }
                    if (previous_slip.lots.length == 0) {
                        if (previous_slip.lot.storage_id == "") {
                            previous_slip.errors.storage_id = ["Storage id field cannot be empty"]
                        } else {
                            delete previous_slip.errors.storage_id
                        }
                        if (previous_slip.lot.lot_no == "") {
                            previous_slip.errors.lot_no = ["Lot No. field cannot be empty"]
                        } else {
                            delete previous_slip.errors.lot_no
                        }
                        if (previous_slip.lot.loading_bags == "") {
                            previous_slip.errors.loading_bags = ["Loading bags field cannot be empty"]
                        } else {
                            delete previous_slip.errors.loading_bags
                        }
                        if (previous_slip.lot.loading_quantity == "") {
                            previous_slip.errors.loading_quantity = ["Loading quantity field cannot be empty"]
                        } else {
                            delete previous_slip.errors.loading_quantity
                        }
                    }
                } else {
                    vm.trip.slips.push({
                        slip_id: "",
                        slip_no: "",
                        slip_date_time: "",
                        work_order_no: "",
                        product_id: "",
                        packing_id: "",
                        loading_type_id: "",
                        pallet_size_id: "",
                        status: true,
                        lots: [],
                        work_order_no: "",
                        loading_type_id: "",
                        pallet_size_id: "",
                        lot: {
                            lot_id: "",
                            storage_id: "",
                            lot_no: "",
                            loading_bags: "",
                            loading_quantity: "",
                        },
                        errors: []
                    });
                }
            }
        },
        convertDateTimeFormat(date) {
            let vm = this;
            return moment(date).format('yyyy-MM-DD HH:mm:ss')

        },
        convertDateFormat(date) {
            let vm = this;
            return moment(date).format('yyyy-MM-DD')

        },
        reset() {
            let vm = this;
            vm.trip.container_no = ""
            vm.trip.customer_id = ""
            vm.trip.transporter_id = ""
            vm.trip.wagon_no = ""
            vm.trip.container_no = ""
            vm.trip.destination = ""
            vm.trip.note = ""
            vm.trip.slips = []
            vm.trip.deleted_lots = []
            vm.addSlip()
        },

        deleteSlip(slip, key) {
            let vm = this;
            let deletedSlips = [];
            console.log("slips", vm.trip.slips)
            let slips = vm.trip.slips.filter(function (element) {
                return element.slip_id != slip.slip_id;
            })
            console.log("slipsss", key)

            let deleted_slip = vm.trip.slips.filter(function (element) {
                return element.slip_id == slip.slip_id && element.slip_id != "" && slip.slip_id != "";
            })
            if (slips.length) {
                vm.trip.slips = slips;
            } else {
                let slip = vm.trip.slips.splice(key, 1)
                console.log(slip)
                console.log(vm.trip.slips)
            }
            if (deleted_slip.length) {
                deletedSlips.push(slip.slip_id);
            }
            vm.trip.deleted_slips = deletedSlips;
            // console.log("slips------",slips);
            console.log("deletedslips------", deletedSlips);

        }
    },
};
</script>

<style scoped>
.icon_hgt_25 {
    font-size: 25px !important;
}

.card-one {
    height: auto !important;
}
</style>
